<template>
  <div class="rounded-lg border border-slate-600/70 bg-slate-900/35 p-3 space-y-2">
    <div class="flex items-center justify-between gap-2">
      <p class="text-sm font-medium text-slate-200">URLs</p>
      <button
        type="button"
        class="whitespace-nowrap text-xs px-2 py-2 rounded border border-cyan-400/40 text-cyan-200 hover:bg-cyan-400/10"
        @click="$emit('add-url')"
      >
        + URL
      </button>
    </div>
    <div class="space-y-2">
      <div
        v-for="(u, idx) in urls"
        :key="`kurl-${idx}`"
        class="flex items-center gap-2"
      >
        <input
          :value="u"
          type="url"
          placeholder="https://exemplo.com/pagina ou https://exemplo.com/sitemap.xml"
          class="w-full px-3 py-2 rounded-lg border border-slate-500/70 bg-slate-900/50 text-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-400/30"
          @input="$emit('update-url', { index: idx, value: $event.target.value })"
        />
        <button
          type="button"
          class="text-red-300 hover:text-red-200 transition text-xl leading-none px-1 shrink-0"
          title="Remover"
          aria-label="Remover URL"
          @click="$emit('remove-url', idx)"
        >
          ×
        </button>
      </div>
    </div>
    <p class="text-xs text-slate-400 leading-snug">
      Aceita páginas ou sitemap.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AgentUrls',
  props: {
    urls: { type: Array, default: () => [] }
  },
  emits: ['add-url', 'remove-url', 'update-url']
}
</script>
